/* eslint-disable react/prop-types */
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

function ModalDetailsMotivo({ descricao, isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <ModalHeader toggle={onClose}>Detalhes do motivo</ModalHeader>
      <ModalBody>
        <p>{descricao || "Nenhuma descrição disponível."}</p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalDetailsMotivo;
